// extracted by mini-css-extract-plugin
export default {"allAnswersPointsContainer":"AllAnswersSamePoints_allAnswersPointsContainer__dH74P"};